import React from 'react';
import ParliamentRedirect from '../ParliamentRedirect/ParliamentRedirect';

const FunParliament: React.FC = () => {
    return <ParliamentRedirect parliamentName="Fun Parliament" />;
};

export default FunParliament;
